/* src/app/shared/components/navigation-bar/navigation-bar.component.scss */
:host {
  display: block;
  width: 100%;
}
.nav-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  margin-bottom: 16px;
}
.nav-actions__right {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}
.nav-actions button {
  display: flex;
  align-items: center;
  gap: 8px;
}
/*# sourceMappingURL=navigation-bar.component.css.map */
